import classNames from 'classnames'
import useTranslate from 'modules/local/useTranslate'
import React from 'react'
import {renderIf} from 'views/Shared'
import {GoDotFill} from 'react-icons/go'

export const ItemInformation = ({
  label,
  value,
  className = 'text-base italic',
  showIcon = false,
  colon = true,
  primary = false,
  style,
}) => {
  const t = useTranslate()
  return renderIf(
    value,
    // flex flex-wrap (thay div thường + space-x-1) - trước đây icon/label/value chỉ trông cậy vào
    // inline flow mặc định để tự nằm cạnh nhau, nhưng icon (svg, Tailwind preflight set display:
    // block) và value dài/không đoán trước được (vd 1 component khác lồng vào như EmptyNote) làm
    // vỡ flow đó theo cách khó đoán - từng thấy thực tế: icon tách riêng ra 1 dòng trống phía trên,
    // label+value dồn xuống dòng dưới rồi tràn ra ngoài card trên mobile hẹp. flex-wrap tường minh +
    // min-w-0 trên value cho phép value tự xuống dòng/wrap gọn gàng trong đúng khung card.
    <div
      style={style}
      className={classNames('flex flex-wrap items-baseline gap-x-1 gap-y-0.5 w-full', className)}>
      {renderIf(
        showIcon === true,
        <GoDotFill
          size={className ? 10 : 12}
          className="text-color-400 flex-shrink-0"
        />
      )}
      {renderIf(
        label,
        <span className="text-color-400 whitespace-no-wrap italic flex-shrink-0">
          {colon ? `${t(label)}: ` : t(label)}
        </span>
      )}
      <span
        className={classNames(
          'min-w-0 break-words',
          primary === true
            ? 'font-bold text-gray-800'
            : value
            ? 'font-semibold text-color-100'
            : 'text-color-300 italic'
        )}>
        {value ? value : t('not update')}
      </span>
    </div>
  )
}
